var _circle, _g, _path, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleMixAndMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    fill: "#e4d0bf",
    r: 23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.653 20.137h17.513c1.135 0 1.783.848 1.611 1.663-.342 1.622-1.074 3.618-2.613 5.199-1.513 1.554-3.892 2.799-7.722 2.799-3.822 0-6.21-1.241-7.738-2.793-1.553-1.58-2.304-3.572-2.66-5.194-.18-.818.467-1.674 1.61-1.674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.731 16.613l1.19 2.332 1.143-2.332",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.767 20.11a3.702 3.702 0 01-.7-2.173c0-1.896 1.171-3.048 2.967-3.199.666-.778 1.325-1.625 2.863-1.625s1.966.847 2.631 1.625c1.796.151 3.2 1.303 3.2 3.199a3.71 3.71 0 01-.701 2.172M11.226 20.108a3.998 3.998 0 01-.003-5.623c.127-.125.338-.245.473-.197a.67.67 0 01.471.194l4.705 4.688c.259.258.259.678 0 .937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.402 15.04c.29-2.428 2.042-4.259 4.075-4.259.326 0 .59.322.59.718v8.61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23h18v14H16z",
    fill: "#e4d0bf"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.226 33.492h12.746a1 1 0 00.994-.89l.722-6.494a1.001 1.001 0 00-.995-1.11h-14.19c-.595 0-1.06.518-.993 1.11l.721 6.494a1 1 0 00.995.89z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.686 27.927h19.825",
    strokeLinecap: "round"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--mix-and-match-920e534171492d16b8411000e8fd9853.svg";
export { SvgIconCircleMixAndMatch as Component };